{
  "Earlier": "ANTERIORMENTE",
  "newNotification": "{newCount} nova notificação",
  "newNotifications": "{newCount} novas notificações",
  "noNotifications": "Você receberá informações importantes sobre nossos produtos, sua colaboração com outros usuários e outras atualizações relevantes",
  "noNotificationsTitle": "As notificações aparecerão aqui"
}
